// Module A — Post-Discharge Care Coordination Engine (Transition Board)
// Cola de altas recientes con LACE+, ventana TCM y closed-loop de follow-up.

import PostDischargePage from "./pages/PostDischargePage";

// Export routes for AppRouter
export const postDischargeRoutes = [
  {
    path: "/post-discharge",
    element: <PostDischargePage />,
  },
];

// Export components for external use
export { default as PostDischargePage } from "./pages/PostDischargePage";
